import type { CartonAlias, CartonMeasure } from '@skupreme/api-contracts/core';
import { CommonUtility } from '@utility/common';

/* How a carton reads in a table cell, in the organisation's unit system. */

const show = (value: unknown) => CommonUtility.getFixNumber(Number(value) || 0);

function length(
  value: number | undefined,
  unit: string | undefined,
  imperial: boolean,
) {
  const n = Number(value) || 0;

  const inInches = unit === 'inch' || unit === 'in';

  if (imperial) {
    return show(inInches ? n : CommonUtility.centiToInch(n));
  }

  return show(inInches ? CommonUtility.inchToCenti(n) : n);
}

/** "10 x 20 x 30 cm", or "-" without a length. */
export function cartonSize(alias: Partial<CartonAlias>, imperial: boolean) {
  if (!alias.carton_length) return '-';

  /* The height's unit stands for all three, as it always has. */
  const unit = alias.carton_height?.unit;
  const sides = [
    alias.carton_length?.value,
    alias.carton_width?.value,
    alias.carton_height?.value,
  ].map(side => length(side, unit, imperial));

  return `${sides.join(' x ')} ${imperial ? 'in.' : 'cm'}`;
}

/** "12 kg" / "26.46 lb", or "-" without a weight. */
export function cartonWeight(
  measure: CartonMeasure | undefined,
  imperial: boolean,
) {
  if (!measure?.value) return '-';

  const { value, unit } = measure;

  if (imperial) {
    return `${show(unit === 'lb' ? value : CommonUtility.kiloToPound(value))} lb`;
  }

  return `${show(unit === 'lb' ? CommonUtility.poundToKilo(value) : value)} kg`;
}

export function unitsPerCarton(alias: Partial<CartonAlias>) {
  return alias.units_per_carton
    ? CommonUtility.numberWithCommas(
        CommonUtility.getFixNumber(alias.units_per_carton),
      )
    : '-';
}
